export enum Periods {
  ONE_SECOND = 1000,
  ONE_MINUTE = 60 * 1000,
  ONE_HOUR = 3600 * 1000,
  ONE_DAY = 24 * 3600 * 1000,
  ONE_WEEK = 7 * 24 * 3600 * 1000,
  ONE_YEAR = 24 * 3600 * 1000 * 365.25,
}
